const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contact service",
  description: "Welcome to contact service",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Team bandenhandel",
    car: "Team autodealers",
    lkw: "Team vrachtwagens",
    em_otr: "Team EM/OTR",
    farm_tractor: "Team landbouwtractoren",
    bandag: "Team Bandag",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "CONTACT EN SERVICE",
      description:
        "Van het gebruik van Bridgestone Plus tot de opvolging van uw bestellingen – ons team staat voor u klaar bij elke stap.  Hieronder vindt u de juiste contactpersonen voor uw vragen",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        short_desc: "",
        description: "",
      },
      bridgestone: {
        title: "BRIDGESTONE PLUS ONDERSTEUNING",
        short_desc:
          "Heeft u een vraag over het gebruik van het Bridgestone Plus-platform?\n" +
          "Ons team helpt u graag verder.",
        description:
          "Voor alle vragen over het gebruik van het Bridgestone Plus-platform of de verschillende toepassingen ervan, kunt u contact met ons opnemen via het volgende e-mailadres: plusbelux&commat;bridgestone.eu ",
      },
      dekouple: {
        title: "SHOP ONDERSTEUNING",
        short_desc:
          "Voor vragen over uw productbestelling (met uitzondering van Bridgestone-artikelen of bandbestellingen), kunt u contact opnemen via het toegewezen emailadres.",
        description:
          "<b>Een vraag over uw bestelling in de Bridgestone-shop (met uitzondering van Bridgestone-artikelen of bandbestellingen)?</b> Of het nu gaat om beschikbare producten, een geplaatste bestelling, leveringstermijnen of het volgen van de levering: u kunt rechtstreeks contact opnemen met onze leverancier, <b>Dekuple Coup de Poing</b>, via e-mail op het adres bridgestoneplus.be&#64;coupdepoing.com.",
      },
      premium_partner: {
        title: "BRIDGESTONE ITEMS SHOP ONDERSTEUNING",
        titlePage: "BRIDGESTONE ITEMS - SHOP ONDERSTEUNING",
        short_desc:
          "Voor vragen met betrekking tot uw <span class='text-danger'>bestelling van Bridgestone- of Firestone-producten</span> kunt u contact opnemen met uw toegewijde klantenserviceteam.",
        description:
          "<div>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Heeft u een vraag over uw</strong> <strong>bestelling in de Bridgestone items - shop</strong> <strong>?</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Neem rechtstreeks contact op met ons supportteam via e-mail:</strong> <a href='mailto:collection.support.ext&#64;bridgestone.eu' style='text-decoration:none;'><strong><u><span style='color:#467886;'>collection.support.ext&#64;bridgestone.eu</span></u></strong></a></p>" +
          "</div>",
        content:
          "<div>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>U kunt ook onze onderstaande FAQ raadplegen:</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Verzending &amp; Retourneren</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Levertijd in de Benelux (België / Nederland / Luxemburg)</strong> : 3 tot 5 werkdagen, vanaf het moment dat uw bestelling is bevestigd.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Verzendkosten</strong> : Verzendkosten zijn inbegrepen in de stukprijs van de producten.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>Alle bestellingen worden verzekerd verzonden en u ontvangt een trackingnummer.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Veelgestelde Vragen (FAQ)</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Kan ik mijn bestelling wijzigen nadat deze is bevestigd en betaald?</strong><br>Nee, aangezien het systeem volledig geautomatiseerd is, is het niet mogelijk om een bestelling te wijzigen nadat deze is bevestigd.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Hoe kan ik mijn levering volgen?</strong><br>Zodra uw bestelling is verzonden, ontvangt u een e-mail van onze logistieke partner met een track & trace-link.<br>Heeft u deze e-mail niet ontvangen? Neem dan contact op met ons supportteam via e-mail. Als u binnen 2-3 dagen geen trackingmail ontvangt, controleer dan uw spamfolder of neem contact op met ons supportteam. We vermelden ook de responstijd van het supportteam.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Ik heb mijn pakket ontvangen, maar mijn bestelling is niet compleet.</strong><br>Neem contact op met ons supportteam. In samenwerking met onze logistieke afdeling analyseren wij het verzendproces.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Ik heb mijn pakket ontvangen, maar sommige artikelen zijn beschadigd.</strong><br>Neem binnen 7 werkdagen na ontvangst contact op met ons supportteam.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Retourprocedure</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>Productretouren worden uitsluitend geaccepteerd in geval van schade of een fout bij de orderverwerking.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Kan ik de door mij bestelde producten retourneren?</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>In geval van schade of een fout bij de orderverwerking kunnen goederen worden geretourneerd. Retourzendingen worden alleen geaccepteerd indien:<br>• De producten zich in originele staat bevinden<br>• De producten in de originele verpakking zitten<br>• De producten niet zijn gebruikt<br>• Het retourformulier volledig is ingevuld en bij het pakket is gevoegd</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>Na het retourneren van uw producten dient u een e-mail te sturen naar <a href='mailto:plusbelux&#64;bridgestone.eu' style='text-decoration:none;'><u><span style='color:#467886;'>plusbelux&#64;bridgestone.eu</span></u></a> om uw punten terug te laten boeken.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><strong>Hoe retourneer ik een product?</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>STAP 1 : Neem contact op met ons supportteam<br>STAP 2 : Na beoordeling van uw aanvraag ontvangt u een retourformulier<br>STAP 3 : Vul het retourformulier in en voeg een papieren kopie toe aan uw zending<br>STAP 4 : Stuur de digitale versie van het formulier naar ons supportteam</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><br><strong>Wie betaalt de retourkosten?</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>De directe kosten van de retourzending zijn voor uw rekening, behalve in geval van transportschade.</p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'><br><strong>Retouradres</strong></p>" +
          "<p style='margin-top:0pt; margin-bottom:8pt;'>Distrimedia<br>Meulebeeksesteenweg 20<br>8700 Tielt<br>België</p>" +
          "</div>",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
